import React from 'react'
import { capitalize, isNil } from 'lodash'
import Head from 'next/head'
import { PropTypes } from 'prop-types'

import { ResultPageTypes } from '~/helpers/constants'

/**
 * Helpers
 */

const getDescriptionPerType = (type, name) => {
  if (type === ResultPageTypes.author) {
    return `Contenido escrito por ${name}`
  }
  if (type === ResultPageTypes.category) {
    return `Contenido de la categoría ${name}`
  }
  if (type === ResultPageTypes.tag) {
    return `Contenido tagueado como ${name}`
  }

  if (type === ResultPageTypes.search) {
    return `Resultados de búsqueda de ${name}`
  }

  return 'Contenido de DJ Mag Latinoamérica'
}

const getTitlePerType = (type, name) => {
  if (type === ResultPageTypes.author) {
    return `Autor - ${capitalize(name)}`
  }
  if (type === ResultPageTypes.category) {
    return `Categoría - ${capitalize(name)}`
  }
  if (type === ResultPageTypes.tag) {
    return `Tag - ${capitalize(name)}`
  }
  if (type === ResultPageTypes.search) {
    return `Buscar - ${name}`
  }

  return 'Contenido de DJ Mag Latinoamérica'
}

/**
 * ResultsHead
 */

const ResultsHead = ({ name, type, image }) => {
  const metaDescription = getDescriptionPerType(type, name)
  const title = getTitlePerType(type, name)

  return (
    <Head>
      <title>{`${title} - ${process.env.NEXT_PUBLIC_SITE_NAME}`}</title>

      <meta name="title" content={title} />
      <meta name="description" content={metaDescription} />

      <meta property="og:title" content={title} key="ogTitle" />
      <meta property="og:description" content={metaDescription} key="ogDescription" />

      <meta property="twitter:title" content={title} key="twitterCardTitle" />
      <meta property="twitter:description" content={metaDescription} key="twitterCardDescription" />

      {!isNil(image) && (
        <>
          <meta property="og:image" content={image} key="ogImage" />
          <meta property="twitter:image" content={image} key="twitterCardImage" />
        </>
      )}
    </Head>
  )
}

/**
 * PropTypes
 */

ResultsHead.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  image: PropTypes.string,
}

/**
 * Exports
 */

export default ResultsHead
